import { formatAmount } from 'utils';
import { tryToRoundToZeroPointNinetyNine } from 'features/premium/tryToRoundToZeroPointNinetyNine';
import { TierPeriod } from 'features/premium/entities';
import { tierThemes } from 'features/premium/benefits';
import { getAnnualDiscountPercentageFromStandard } from 'features/premium/annualDiscount';
export const getMonthlyPrice = (subscription) => {
    switch (subscription.period) {
        case TierPeriod.yearly:
            return formatAmount(tryToRoundToZeroPointNinetyNine(parseFloat(subscription.price) / 12), subscription.currency);
        default:
            return formatAmount(parseFloat(subscription.price), subscription.currency);
    }
};
const getYearlyPriceAmount = (subscription) => {
    switch (subscription.period) {
        case TierPeriod.monthly:
            return parseFloat(subscription.price) * 12;
        default:
            return parseFloat(subscription.price);
    }
};
export const getYearlyPrice = (subscription) => formatAmount(getYearlyPriceAmount(subscription), subscription.currency);
export const getWeeklyPrice = (subscription) => {
    const annualPrice = subscription.period === TierPeriod.monthly
        ? parseFloat(subscription.price) * 12
        : parseFloat(subscription.price);
    return formatAmount(annualPrice / 52, subscription.currency);
};
/**
 * Display data for a set of subscriptions that differ by tier rather than by
 * period, so each card is titled with its tier name. There is no cross-plan
 * saving to quote here — the plans are not comparable periods of the same tier —
 * so no `oldPrice` or `discount` is produced. An optional badge highlights one
 * tier in place of the `SAVE x%` label.
 */
export const transformTierSubscriptionsToDisplayData = (subscriptions, badge) => subscriptions.map((subscription) => {
    const { tier, period, price, currency } = subscription;
    const isMonthly = period === TierPeriod.monthly;
    return {
        period: isMonthly ? 'Monthly' : 'Annual',
        title: tierThemes[tier].name,
        badgeLabel: badge?.tier === tier ? badge.label : undefined,
        newPrice: isMonthly
            ? undefined
            : formatAmount(parseFloat(price), currency),
        monthlyPrice: getMonthlyPrice(subscription),
        weeklyPrice: getWeeklyPrice(subscription),
    };
});
export const transformSubscriptionsToDisplayData = (subscriptions) => {
    if (!subscriptions?.length)
        return [];
    const standardSubscription = subscriptions[subscriptions.length - 1];
    const standardPrice = getYearlyPriceAmount(standardSubscription);
    const biggestPrice = getYearlyPrice(standardSubscription);
    return subscriptions.map((subscription) => {
        const { period, price, currency } = subscription;
        return {
            period: period === TierPeriod.monthly ? 'Monthly' : 'Annual',
            oldPrice: period === TierPeriod.monthly ? undefined : biggestPrice,
            newPrice: period === TierPeriod.monthly
                ? undefined
                : formatAmount(parseFloat(price), currency),
            monthlyPrice: getMonthlyPrice(subscription),
            weeklyPrice: getWeeklyPrice(subscription),
            discount: period === TierPeriod.monthly
                ? undefined
                : getAnnualDiscountPercentageFromStandard(standardPrice, subscription.price),
        };
    });
};
